import { useMemo } from "react";
import { Permission, useUserContext } from "../context/UserContext";
import { useRolesContext } from "../context/ModelContext";
import { LicencedProduct } from "../enums/LicencedProduct";

export const usePermissions = <T extends Permission[]>(
  ...permissionsToCheck: T
): boolean[] => {
  const { isSuperAdmin, roleIdsByProduct } = useUserContext();
  const cherryHubRolesSummary = useRolesContext();

  return useMemo(() => {
    // When we have more products, we might pass in the product name as a param to this function
    const cherryPayRoles = roleIdsByProduct[LicencedProduct.CherryPay] ?? [];
    const assignedPermissions = new Set(
      cherryHubRolesSummary.Roles?.filter((role) =>
        cherryPayRoles.includes(role?.RoleId ?? "")
      ).flatMap((role) => role.Permissions ?? [])
    );

    return permissionsToCheck.map((permission) =>
      isSuperAdmin
        ? true
        : assignedPermissions?.has(permission.replace(".", ""))
    );
  }, [
    ...permissionsToCheck,
    isSuperAdmin,
    roleIdsByProduct,
    cherryHubRolesSummary,
  ]);
};
